<template>
  <b-row>
    <b-col
      cols="12"
    >
      <form-wizard
        ref="refWizard"
        color="#fdb813"
        :title="null"
        :subtitle="null"
        next-button-text="Volgende"
        back-button-text="Terug"
        finish-button-text="Offerte aanvragen"
        layout="vertical"
        class="wizard-vertical mb-3"
        @on-complete="formSubmitted"
        @on-change="scrollToTop"
      >

        <tab-content
          title="Ziektekostenverzekering"
          icon="feather icon-file-text"
          :before-change="validationInsuranceTypeForm"
        >
          <validation-observer
            ref="insuranceType"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Ziektekostenverzekering
                </h5>
                <small>
                  Bereken hier je (indicatieve) premie.
                </small>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="birthDate"
                  rules="required"
                >
                  <b-form-group
                    label="Geboortedatum"
                    label-for="birthDate"
                  >
                    <flat-pickr
                      id="startDate"
                      v-model="calculation.birthDate"
                      :config="birthDateConfig"
                      :state="getValidationState(validationContext)"
                      placeholder="dd-mm-jjjj"
                      @input="calculateAge"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="pzsType"
                  rules="required"
                >
                  <b-form-group
                    label="Kies de gewenste dekking"
                    label-for="pzsType"
                  >
                    <VueRadioButton
                      v-model="calculation.pzsType"
                      :options="pzsButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.birthDate !== null && calculation.birthDate !== ''"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="class"
                  rules="required"
                >
                  <b-form-group
                    label="Kies de gewenste ligklasse"
                    label-for="class"
                  >
                    <VueRadioButton
                      v-model="calculation.class"
                      :options="classButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <tab-content
          title="Gegevens"
          icon="feather icon-user"
          :before-change="validationInformationForm"
        >
          <validation-observer
            ref="information"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Gegevens
                </h5>
                <small>
                  De onderstaande gegevens hebben wij nog nodig om een indicatieve premie voor u te kunnen berekenen.
                </small>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="class"
                  rules=""
                >
                  <b-form-group
                    label="Betalingstermijnen"
                    label-for="class"
                  >
                    <VueRadioButton
                      v-model="calculation.contractDuration"
                      :options="contractDurationButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <tab-content
          title="Premie"
          icon="feather icon-link"
        >
          <b-row>
            <b-col
              cols="8"
              class="mb-2"
            >
              <h5 class="mb-0">
                De indicatieve premie is
              </h5>
            </b-col>
            <b-col
              cols="4"
              class="mb-2"
              style="text-align: right"
            >
              <b-badge
                variant="primary"
                style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                @click="resetForm"
              >
                <feather-icon
                  icon="RefreshCcwIcon"
                  size="18"
                />
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <b-card
                no-body
                class="card-apply-job"
              >
                <div
                  class="apply-job-package bg-light-primary rounded"
                  style="border-bottom-right-radius:0 !important;border-bottom-left-radius:0 !important;"
                >
                  <div>
                    <sup class="text-body">
                      <small>SRD</small>
                    </sup>
                    <h2 class="d-inline mr-25">
                      {{ calculation.premium }}
                    </h2>
                    <!--                    <sub class="text-body"><small>/ month</small></sub>-->
                  </div>
                  <b-badge
                    variant="light-primary"
                    pill
                  >
                    indicatie
                  </b-badge>
                </div>
                <b-card-body>
                  <b-card-text class=" ml-0 mr-0 pl-0 pr-0 mb-2">
                    <h2>Belangrijk</h2>
                    <ul class=" ml-0 mr-0 pl-0 pr-0">
                      <li>De premie is indicatief. Bij het ontvangen van het ingevuld medisch vragenformulier kunnen kortingen en/of toeslagen worden gegeven.</li>
                      <li>De premie is exclusief SRD 50,00 voor poliskosten.</li>
                      <li>De premie is exclusief SRD 15,00 voor pasjeskosten per verzekerde.</li>
                      <li>Toeslag bij zwangerschap zal worden toegepast. De hoogte hiervan zal door de verzekeraar worden bepaald. De premie bij zwangerschap zal meteen per jaar moeten worden voldaan.</li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content
          title="Offerte"
          icon="feather icon-map-pin"
        >
          <validation-observer
            ref="offer"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Adres
                </h5>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="firstName"
                  rules="required"
                >
                  <b-form-group
                    label="Voornaam"
                    label-for="firstName"
                  >
                    <b-form-input
                      id="firstName"
                      v-model="calculation.firstName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="lastName"
                  rules="required"
                >
                  <b-form-group
                    label="Achternaam"
                    label-for="lastName"
                  >
                    <b-form-input
                      id="lastname"
                      v-model="calculation.lastName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="phone"
                  rules="required|integer|min:6"
                >
                  <b-form-group
                    label="Telefoonnummer"
                    label-for="phone"
                  >
                    <b-form-input
                      id="phone"
                      v-model="calculation.phoneNumber"
                      type="text"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="email"
                  rules="required|email"
                >
                  <b-form-group
                    label="E-mailadres"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="calculation.email"
                      type="email"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
      </form-wizard>
    </b-col>
  </b-row>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInvalidFeedback, BBadge, BCardBody, BFormInput, BCard, BCardText,
} from 'bootstrap-vue'
import {
  required,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import VueRadioButton from '@/views/components/VueRadioButton.vue'
import pzsStoreModule from '@/views/pages/pzs/pzsStoreModule'
import { countryList, districtsList, surinameCityList } from '@core/utils/list'
import Ripple from 'vue-ripple-directive'
import {
  formatDate, formatDateTime, formatPrice, getAge,
} from '@core/utils/utils'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    flatPickr,
    BFormInvalidFeedback,
    BBadge,
    BCardBody,
    BFormInput,
    BCard,
    BCardText,
    VueRadioButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      calculation: {
        pzsType: null,
        birthDate: null,
        class: null,
        contractDuration: null,
        premium: null,
        firstName: null,
        lastName: null,
        address: null,
        phoneNumber: null,
        email: null,
        emailText: '',
      },
      blankCalculation: {
        pzsType: null,
        birthDate: null,
        class: null,
        contractDuration: null,
        premium: null,
        firstName: null,
        lastName: null,
        address: null,
        phoneNumber: null,
        email: null,
        emailText: '',
      },
      birthDateConfig: {
        maxDate: 'today',
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
      },
      pzsButtons: [
        {
          id: 1,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/safety.svg'),
          title: 'Basis',
          key: 'type',
        },
        {
          id: 2,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/safetyplus.svg'),
          title: 'Comfort',
          key: 'type',
        },
      ],
      classButtons: [
        {
          id: 'class1',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/packing.svg'),
          title: '1',
          key: 'class',
        },
        {
          id: 'class2',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/packing.svg'),
          title: '2',
          key: 'class',
        },
        {
          id: 'class3',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/packing.svg'),
          title: '3',
          key: 'class',
        },
      ],
      contractDurationBasicButtons: [
        {
          id: 6,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per halfjaar',
          key: 'contractDuration',
        },
        {
          id: 12,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per jaar',
          key: 'contractDuration',
        },
      ],
      contractDurationComfortButtons: [
        {
          id: 1,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per maand',
          key: 'contractDuration',
        },
        {
          id: 6,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per halfjaar',
          key: 'contractDuration',
        },
        {
          id: 3,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per kwartaal',
          key: 'contractDuration',
        },
        {
          id: 12,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/calendar.png'),
          title: 'Per jaar',
          key: 'contractDuration',
        },
      ],
      showDurationPayment: false,
    }
  },
  computed: {
    contractDurationButtons() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.showDurationPayment = false
      if (this.calculation.pzsType === '1') {
        return this.contractDurationBasicButtons
        // eslint-disable-next-line no-unreachable,vue/no-side-effects-in-computed-properties
        this.showDurationPayment = true
      }
      if (this.calculation.pzsType === '2') {
        return this.contractDurationComfortButtons
        // eslint-disable-next-line no-unreachable,vue/no-side-effects-in-computed-properties
        this.showDurationPayment = true
      }

      return []
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    resetForm() {
      this.calculation = JSON.parse(JSON.stringify(this.blankCalculation))
      this.$refs.insuranceType.reset()
      this.$refs.information.reset()
      this.$refs.offer.reset()
      this.$refs.refWizard.reset()
    },
    setPzsType(type) {
      this.calculation.pzsType = type
    },
    validationInsuranceTypeForm() {
      return new Promise((resolve, reject) => {
        this.$refs.insuranceType.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationInformationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.information.validate().then(success => {
          if (success) {
            this.calculation.class = this.calculation.class.replace('class', '')
            store.dispatch('app-pzs/calculate', this.calculation)
              .then(response => {
                this.calculation.premium = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(response.data.premium)
                resolve(true)
              })
              .catch(() => {
                reject()
              })
          } else {
            reject()
          }
        })
      })
    },
    formSubmitted() {
      this.$refs.offer.validate().then(success => {
        if (success) {
          this.calculation.emailText = `
          <h3>Ziektekostenverzekering</h3>
          Gewenste dekking: ${this.calculation.pzsType ? this.pzsButtons.filter(f => String(f.id) === String(this.calculation.pzsType))[0].title : ''}<br/>
          Geboortedatum: ${this.calculation.birthDate ? formatDate(this.calculation.birthDate) : ''}<br/>
          Ligklasse: ${this.calculation.class ? this.classButtons.filter(f => String(f.id).replace('class', '') === String(this.calculation.class))[0].title : ''}<br/>
          Betalingstermijn: ${this.calculation.contractDuration ? this.contractDurationBasicButtons.filter(f => String(f.id) === String(this.calculation.contractDuration))[0].title : ''}<br/>
          Premie indicatie: ${this.calculation.premium ? this.calculation.premium : ''}
          `
          store.dispatch('app-pzs/sendOfferMail', this.calculation)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Offerte aanvraag!',
                text: 'Bedankt voor uw offerte aanvraag, wij zullen spoedig contact met u opnemen.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.resetForm()
              })
            })
            .catch(() => {
              this.$swal({
                icon: 'error',
                title: 'Relatie!',
                text: 'Er is een fout opgetreden bij het verwerken van uw offerte aanvraag. Probeer het later nog een keer.',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              })
            })
        }
      })
    },
    calculateAge() {
      if (getAge(this.calculation.birthDate) < 13) {
        this.classButtons = [
          {
            id: 'class3',
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/packing.svg'),
            title: '3',
            key: 'class',
          },
        ]
      } else {
        this.classButtons = [
          {
            id: 'class1',
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/packing.svg'),
            title: '1',
            key: 'class',
          },
          {
            id: 'class2',
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/packing.svg'),
            title: '2',
            key: 'class',
          },
          {
            id: 'class3',
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/packing.svg'),
            title: '3',
            key: 'class',
          },
        ]
      }
    },
  },
  setup() {
    const PZS_MODULE_NAME = 'app-pzs'

    // Register module
    if (!store.hasModule(PZS_MODULE_NAME)) store.registerModule(PZS_MODULE_NAME, pzsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PZS_MODULE_NAME)) store.unregisterModule(PZS_MODULE_NAME)
    })

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(() => {})

    return {
      refFormObserver,
      getValidationState,
      required,
      countryList,
      surinameCityList,
      districtsList,
      formatPrice,
      formatDateTime,
      formatDate,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.v-radio-label {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  margin: 5px;
  border-radius: 4px;
  //border: 1px solid #eee;
  transition: all 500ms;
  background: rgba(253, 184, 19, 0.12);
  color: #000000;
  font-weight: bold;
  font-size: 12px;
}

.v-radio-active {
  //border: 2px solid #ce2a56;
  background-color: rgba(253, 184, 19, 0.4);
  //box-shadow: 0 1px 5px 0 rgba(206, 42, 86,.12); // #ce2a56 //#f3f2ee
  color: #000000;
  //img {
  //  filter: invert(100%) sepia(53%) saturate(1530%) hue-rotate(290deg) brightness(118%) contrast(102%);
  //}
}
</style>
